export default "__VITE_ASSET__affb59e6__"